import { Api, JsonRpc, Numeric, Serialize } from '@amax/amaxjs-v2';
import { JsSignatureProvider } from '@amax/amaxjs-v2/dist/eosjs-jssig';
import { isApp } from './device';
const isProd = import.meta.env.VITE_APP_NET === 'production';


export function getArmadillo() {
  if (!(window as any).armadillo) {
    throw new Error('请安装Armadillo插件');
  }
  return (window as any).armadillo;
}

/**
 * 获取rpc
 * @returns
 */
export function getRPC(): JsonRpc {
  if ((window as any).armadillo && isProd && isApp) {
    return (window as any).armadillo.rpc;
  }
  return new JsonRpc(import.meta.env.VITE_APP_URL, { fetch: window.fetch });
}


/**
 * 获取client
 * @returns
 */
export async function getArmadilloClient(): Promise<{
  api: Api;
  rpc: JsonRpc;
}> {
  const armadillo = await getArmadillo();
  const signatureProvider = new JsSignatureProvider([]);
  const rpc = getRPC();
  const api = await armadillo.getApi(Api, { rpc, signatureProvider });
  return { api, rpc };
}